// @vendors
import React from 'react'

const EditChargeToPay = ({
    companySelected,
    newAmountDue,
    setNewAmountDue,
    handleCloseEditModal,
    loadingEdit,
    handleSaveAmountDue,
    formatCurrency
}) => {

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold">
                        Editar Costo a Pagar
                    </h3>
                </div>

                <div className="mb-4">
                    <p className="text-gray-600 mb-2">
                        <strong>Empresa:</strong> {companySelected.nombre}
                    </p>
                    <p className="text-gray-600">
                        <strong>Costo actual:</strong> {formatCurrency(companySelected.amountDue)}
                    </p>
                </div>

                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nuevo Costo a Pagar
                    </label>
                    <input
                        type="number"
                        value={newAmountDue}
                        onChange={(e) => setNewAmountDue(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Ingresa el nuevo costo"
                        min="0"
                        step="0.01"
                    />
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={handleCloseEditModal}
                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                        disabled={loadingEdit}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSaveAmountDue}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={loadingEdit}
                    >
                        {loadingEdit ? 'Guardando...' : 'Guardar'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditChargeToPay